"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const button_styles_1 = require("./button-styles");
const tooltip_1 = require("../tooltip/tooltip");
function Button({ onClick, label, disabled, outlined = false, contained = false, tooltip, }) {
    const handleClick = event_callback_hook_1.useEventCallback((event) => {
        if (onClick !== undefined) {
            onClick();
        }
        event.stopPropagation();
    });
    const classes = button_styles_1.useStyles();
    return (react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip },
        react_1.default.createElement(Button_1.default, { classes: classes, disabled: disabled, onClick: handleClick, variant: outlined ? 'outlined' : contained ? 'contained' : 'text' }, label)));
}
exports.Button = Button;
//# sourceMappingURL=button.js.map